var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6473 22.5067C14.0115 23.1189 14.246 24.957 13.0792 25.8921L9.83304 28.4934C8.61415 29.4702 6.79609 28.7353 6.59842 27.1858L6.0493 22.8814C5.85163 21.332 7.42696 20.1641 8.85204 20.8036L12.6473 22.5067Z",
    fill: "black",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5099,
    cy: 12.5099,
    r: 12.5099,
    fill: "#E9354D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5099,
    cy: 12.5099,
    r: 12.5099,
    fill: "black",
    fillOpacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9L9 17",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9L17 17",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_1585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.0198,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.27d89d3ae21cf2fd9bab02caadb414a5.svg";
export { ForwardRef as ReactComponent };